import { customEvent } from "goi_common";
import { GOI_PHONE } from "@/constants/contact";
import { PhoneIcon } from "@/components/PhoneIcon";
import { useParlorInquiryModal } from "@/hooks/useParlorInquiryModal";

/**
 * 장례식장 정보 섹션
 * - eyebrow + h1 (장례식장명) + 지역/규모 태그 + 주소(핀 아이콘)
 */

interface QuoteParlorInfoProps {
  parlorId: number;
  parlorName: string;
  region: string;
  managedType: string;
  address: string;
  /** now 콜 확대 B안: 맨 위 임종 배너에 전화 버튼이 있어 제목 옆 전화 버튼은 숨긴다 */
  hidePhoneCta?: boolean;
}

const PinIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

export const QuoteParlorInfo = ({
  parlorId,
  parlorName,
  region,
  managedType,
  address,
  hidePhoneCta = false,
}: QuoteParlorInfoProps) => {
  const { openParlorInquiryModal } = useParlorInquiryModal("parlor_ad_quote");
  const handlePhoneClick = () => {
    customEvent({
      newGtm: {
        path: "parlor_ad_quote",
        trigger_and_target: "btn_phone_hero",
        properties: { parlor_id: parlorId, parlor_name: parlorName },
      },
    });
    void openParlorInquiryModal();
  };
  return (
    <section className="lp-parlor">
      <div className="lp-hero-row">
        <h1>{parlorName}</h1>
        {!hidePhoneCta && (
          <button
            type="button"
            onClick={handlePhoneClick}
            className="lp-hero-phone"
            aria-label={`24시간 전화 ${GOI_PHONE}`}
          >
            <PhoneIcon size={14} />
            <span>24시간 전화</span>
          </button>
        )}
      </div>
      <div className="lp-tags">
        {region && <span className="lp-tag">{region}</span>}
        {managedType && <span className="lp-tag">{managedType}</span>}
      </div>
      <div className="lp-address">
        <PinIcon />
        <span>{address}</span>
      </div>
    </section>
  );
};
